import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { ErrorMsgState, useErrorMsg } from '@/model/components/common/message/errorMessage'
import { useNormalMsg } from '@/model/components/common/message/normalMessage'
import { userEntry } from '@/model/api/user/apiUserEntry'
import { loginDefaultRedirect } from '@/model/components/users/userLoginAuth'
import { LoginRedirectState } from '@/model/components/users/userLoginAuthState'
import { focusBlur } from '@/model/util/dom/domUtil'
import { UserEntryState } from './userEntryState'
import { checkFlowRedirect } from './userNoAuth'

/**
 * ログイン認証画面のDOM初期処理を実施する
 * @param state 状態
 * @param store vuex
 * @param router vue router
 */
const initDom = async (state: UserEntryState, store: Store<StoreState>, router: Router) => {
  // 初期処理チェック(F5等でusernameが未設定の場合はTOP画面に遷移)
  await checkFlowRedirect(state.username, store, router)
}

/**
 * パスワード登録画面の初期状態を取得する
 * @param props propsデータ
 * @returns reactiveした初期状態
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stateUserEntry = (props: any): UserEntryState => {
  const state = reactive<UserEntryState>({
    loading: false,
    username: props.username,
    password: '',
    passwordConfirm: '',
    onetimepassword: props.onetimepassword,
    type: props.type,
    dispPassword: false,
    redirect: props.redirect,
    downloadKey: props.downloadKey,
  })
  return state
}

/**
 * パスワードを登録して画面遷移を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 */
const userPasswordEntry = async (
  state: UserEntryState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState
) => {
  // 一旦メッセージを全て初期化
  error.data.splice(0)
  // モバイルのためにfocusを外す
  focusBlur()
  // ローディングをONにする
  state.loading = true
  // api送信を実施
  const result = await userEntry(store).entry(state, error)
  // ローディングをOFFにする
  state.loading = false
  if (result.result) {
    // 正常時の場合は認証処理を行って、ダウンロード画面に遷移する
    const input: LoginRedirectState = {
      username: state.username,
      password: state.password,
      redirect: state.redirect,
      downloadKey: state.downloadKey,
    }
    await loginDefaultRedirect(input, store, router, error)
  }
}

export { initDom, stateUserEntry, userPasswordEntry, useErrorMsg, useNormalMsg }
